@if (filteredOptions()) {
  <form [formGroup]="form()" class="type-ahead">
    <mat-form-field [class]="{ 'form-field-hide-notch': !label() }">
      <mat-label>{{ label() }}</mat-label>
      <input
        #input
        matInput
        [formControlName]="controlName()"
        [matAutocomplete]="auto"
        #trigger="matAutocompleteTrigger"
        [appAutoFocus]="focus()"
        [required]="label() ? isRequired(null, control) : false"
        [class]="{ 'bold-record': control?.value | function: checkForBold }"
        (keydown)="onKeyDown($event)"
        (blur)="closePanel()"
      />

      <button
        [hidden]="!(control?.value && control?.enabled)"
        type="button"
        tabIndex="-1"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        [matTooltip]="'APP.LBL_CLEAR' | transloco"
        (click)="clear()"
      >
        <mat-icon [fontSet]="'' | function: userDefinedIconFontSet | async" [fontIcon]="icons.CLEAR"></mat-icon>
      </button>

      <mat-autocomplete
        #auto="matAutocomplete"
        showPanel
        [displayWith]="autoCompleteDisplay.bind(this)"
        (optionSelected)="onSelect()"
        appTypeAheadScroll
        [autoComplete]="auto"
        (optionsScroll)="onScroll()"
      >
        @for (opt of filteredOptions(); track opt[valueName()]) {
          <mat-option
            [value]="opt[valueName()]"
            [appScrollToElement]="control?.value === opt[valueName()]"
            [class]="{
              'active-record': control?.value === opt[valueName()],
              'bold-record': boldValueName() ? opt[boldValueName()] : false
            }"
            (mousedown)="$event.preventDefault()"
          >
            <span [innerHTML]="opt[displayName()] + ' ' + (displayName2() ? '(' + opt[displayName2()] + ')' : '') | bold: control?.value"></span>
          </mat-option>
        }
      </mat-autocomplete>
      <mat-error>{{ (customErrorMsg() && !filteredOptions() ? customErrorMsg() : getError(form(), controlName())) | transloco }}</mat-error>
    </mat-form-field>

    @if (showAction()) {
      <button
        type="button"
        class="type-ahead__button stroked-icon-button"
        stroked-icon-button
        mat-stroked-button
        [matTooltip]="actionTooltip()"
        appClickStop
        (debounceClick)="onActionClicked()"
      >
        <mat-icon [fontSet]="'' | function: userDefinedIconFontSet | async" [fontIcon]="actionIcon()"></mat-icon>
      </button>
    }
  </form>
}
